import { render, staticRenderFns } from "./LoyaltyPoints.vue?vue&type=template&id=4992758e&scoped=true&"
import script from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPoints.vue?vue&type=style&index=0&id=4992758e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4992758e",
  null
  
)

export default component.exports